import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const MinimizeExpand = (props: SvgIconProps) => {
    return (
        <SvgIcon viewBox="0 0 16 16" {...props} fill="none">
            <g clipPath="url(#clip0_4347_434)">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M2.30981 2.31029C2.93493 1.68517 3.78277 1.33398 4.66683 1.33398H11.3335C12.2176 1.33398 13.0654 1.68517 13.6905 2.31029C14.3156 2.93542 14.6668 3.78326 14.6668 4.66732V11.334C14.6668 12.218 14.3156 13.0659 13.6905 13.691C13.0654 14.3161 12.2176 14.6673 11.3335 14.6673H4.66683C3.78277 14.6673 2.93493 14.3161 2.30981 13.691C1.68469 13.0659 1.3335 12.218 1.3335 11.334V4.66732C1.3335 3.78326 1.68469 2.93542 2.30981 2.31029ZM4.66683 2.66732C4.1364 2.66732 3.62769 2.87803 3.25262 3.2531C2.87754 3.62818 2.66683 4.13688 2.66683 4.66732V11.334C2.66683 11.8644 2.87754 12.3731 3.25262 12.7482C3.62769 13.1233 4.1364 13.334 4.66683 13.334H11.3335C11.8639 13.334 12.3726 13.1233 12.7477 12.7482C13.1228 12.3731 13.3335 11.8644 13.3335 11.334V4.66732C13.3335 4.13688 13.1228 3.62818 12.7477 3.2531C12.3726 2.87803 11.8639 2.66732 11.3335 2.66732H4.66683Z"
                    fill="#555453"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6.665 2C7.03227 2 6.665 2 7.33 2.00001V14C6.53328 14 7.03227 14 6.665 14C6.29773 14 6.85573 14 6 14V2.00001C6.665 2.00001 6.29773 2 6.665 2Z"
                    fill="#555453"
                />
            </g>
            <defs>
                <clipPath id="clip0_4347_434">
                    <rect width="16" height="16" fill="white" />
                </clipPath>
            </defs>
        </SvgIcon>
    );
};

export default MinimizeExpand;
